const IS_DEVELOPMENT = false; // Change to true for local and false for production build

// Base URL configuration loaded from api-config.json
let configBaseUrl = null;

// Portal folder from the current page URL (e.g. "csportal" from /csportal/)
const getFolderPath = () => {
  const pathSegments = window.location.pathname.split('/');
  const portalSegment = pathSegments.filter(segment => segment)[0];
  return portalSegment || '';
};

// Resolve api-config.json relative to the call URL first, then fall back
const getApiConfigCandidates = () => {
  const folderPath = getFolderPath();
  const candidates = [];
  if (folderPath) {
    candidates.push(`/${folderPath}/api-config.json`);
  }
  candidates.push('./api-config.json');
  candidates.push('/api-config.json');
  return candidates;
};

// Load config from api-config.json synchronously before endpoints are computed
const loadApiConfigSync = () => {
  for (const path of getApiConfigCandidates()) {
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', path, false);
      xhr.send();

      if (xhr.status === 200 || xhr.status === 0) {
        const config = JSON.parse(xhr.responseText);
        configBaseUrl = config.baseUrl || null;
        return;
      }
    } catch (error) {
      // Try next candidate
    }
  }
  // Default to same-origin / call-URL based paths if config can't be loaded
  configBaseUrl = null;
};

loadApiConfigSync();

// Get base URL with fallback to the current call URL (same origin)
const getBaseUrl = () => {
  // If config.baseUrl is null or empty, follow the page URL
  if (!configBaseUrl || configBaseUrl.trim() === '') {
    // Local: relative paths (works with CRA proxy). Production: current origin.
    return IS_DEVELOPMENT ? '' : window.location.origin;
  }

  // In development mode, extract only the path from the full URL
  // e.g., "https://test.tribald.com/pbp" becomes "/pbp"
  if (IS_DEVELOPMENT) {
    try {
      const url = new URL(configBaseUrl);
      return url.pathname.replace(/\/$/, '') || '';
    } catch (error) {
      // If not a valid URL, treat as path
      return configBaseUrl.startsWith('/') ? configBaseUrl : `/${configBaseUrl}`;
    }
  }

  // In production mode, return the full URL as is
  return configBaseUrl.replace(/\/$/, '');
};

// Build endpoint URLs
const buildEndpoint = (endpoint) => {
  const baseUrl = getBaseUrl();

  // If config.baseUrl was null or empty, use call-URL folder path
  if (!configBaseUrl || configBaseUrl.trim() === '') {
    const folderPath = getFolderPath();
    if (!folderPath) {
      return `${baseUrl}/api/${endpoint}`;
    }
    return `${baseUrl}/${folderPath}/api/${endpoint}`;
  }

  return `${baseUrl}/api/${endpoint}`;
};

// Endpoint definitions
const endpoints = {
  INS: 'ins.aspx',
  UTILS: 'utils.aspx',
  CCTHUTILS: 'ccthutils.aspx',
  PBPUTILS: 'pbputils.aspx',
  CRITUTILS: 'critutils.aspx',
  POKUTILS: 'pokutils.aspx',
  CSPUTILS: 'csputils.aspx'
};

// Export endpoints
export const INS = buildEndpoint(endpoints.INS);
export const UTILS = buildEndpoint(endpoints.UTILS);
export const CCTHUTILS = buildEndpoint(endpoints.CCTHUTILS);
export const PBPUTILS = buildEndpoint(endpoints.PBPUTILS);
export const CRITUTILS = buildEndpoint(endpoints.CRITUTILS);
export const POKUTILS = buildEndpoint(endpoints.POKUTILS);
export const CSPUTILS = buildEndpoint(endpoints.CSPUTILS);

// Export getter functions for dynamic endpoint resolution
export const getINS = () => buildEndpoint(endpoints.INS);
export const getUTILS = () => buildEndpoint(endpoints.UTILS);
export const getCCTHUTILS = () => buildEndpoint(endpoints.CCTHUTILS);
export const getPBPUTILS = () => buildEndpoint(endpoints.PBPUTILS);
export const getCRITUTILS = () => buildEndpoint(endpoints.CRITUTILS);
export const getPOKUTILS = () => buildEndpoint(endpoints.POKUTILS);
export const getCSPUTILS = () => buildEndpoint(endpoints.CSPUTILS);

// Refresh config (useful if config is updated after initial load)
export const refreshConfig = async () => {
  for (const path of getApiConfigCandidates()) {
    try {
      const response = await fetch(path);
      if (response.ok) {
        const config = await response.json();
        configBaseUrl = config.baseUrl || null;
        return;
      }
    } catch (error) {
      // Try next candidate
    }
  }
  configBaseUrl = null;
};
